// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { faEnvelope, faPhone, faSearch } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// const Header = () => {
//   const [hoveredMenu, setHoveredMenu] = useState(null);
//   const [timeoutId, setTimeoutId] = useState(null);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isBlindsOpen, setIsBlindsOpen] = useState(false);
//   const [isShadesOpen, setIsShadesOpen] = useState(false);
//   const [isBrowseOpen, setIsBrowseOpen] = useState(false);


//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);
  
  
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [expandedMenus, setExpandedMenus] = useState({
//     need: false,
//     shades: false,
//     blinds: false,
//   });

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const toggleMenu = (menu) => {
//     setExpandedMenus((prev) => ({
//       ...prev,
//       [menu]: !prev[menu],
//     }));
//   };
//     useEffect(() => {
//       const handleClickOutside = (event) => {
//         if (
//           isSidebarOpen &&
//           sidebarRef.current &&
//           !sidebarRef.current.contains(event.target) &&
//           !toggleRef.current.contains(event.target)
//         ) {
//           setIsSidebarOpen(false);
//         }
//       };
//       // Add event listener to document
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => {
//         // Cleanup the event listener
//         document.removeEventListener('mousedown', handleClickOutside);
//       };
//     }, [isSidebarOpen]);



//   const handleMouseEnter = (menu) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       setTimeoutId(null);
//     }
//     setHoveredMenu(menu);
//   };

//   const handleMouseLeave = () => {
//     const id = setTimeout(() => {
//       setHoveredMenu(null);
//     }, 300); // Delay before closing the dropdown
//     setTimeoutId(id);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen((prev) => !prev);
//   };

//   const toggleBlindsMenu = () => {
//     setIsBlindsOpen((prev) => !prev);
//   };

//   const toggleShadesMenu = () => {
//     setIsShadesOpen((prev) => !prev);
//   };

//   const toggleBrowseMenu = () => {
//     setIsBrowseOpen((prev) => !prev);
//   };

//   return (
//     <header  className= "  font-normal   bg-white  w-full z-50">
       
       

//        <div className="fixed top-0 left-0 w-full bg-white  z-50">
//       <div className="mx-auto flex items-center justify-between py-3 px-4 md:px-20">

//         {/* 🔹 Logo */}
//         <div className="text-3xl text-gray-800">
//           <a href="/">
//             <img className="w-32 h-16" src="images/dsgo.png" alt="Logo" />
//           </a>
//         </div>

//         {/* 🔹 Desktop Navigation */}
//         <nav className="hidden lg:flex gap-6 xl:gap-12 items-center">
//           <Link to="/aboutus" className="text-lg font-medium text-gray-600 hover:text-black transition">
//             About Us
//           </Link>

//           {/* Business Areas Dropdown */}
//           <div className="relative group">
//             <button className="text-lg font-medium text-gray-600 hover:text-black transition">
//               Business Areas
//             </button>
//             <ul className="absolute left-0 mt-2 bg-black text-white rounded-md w-64 shadow-lg hidden group-hover:block">
//               <li><Link to="/cofee" className="block py-2 px-4 hover:bg-gray-800">Coffee Shop</Link></li>
//               <li><Link to="/bakerypastry" className="block py-2 px-4 hover:bg-gray-800">Bakery & Pastry</Link></li>
//               <li><Link to="/butchery" className="block py-2 px-4 hover:bg-gray-800">Butchery & Charcuterie</Link></li>
//               <li><Link to="/" className="block py-2 px-4 hover:bg-gray-800">Supermarket</Link></li>
//               <li><Link to="/" className="block py-2 px-4 hover:bg-gray-800">Take-Away</Link></li>
//               <li><Link to="/restaurent" className="block py-2 px-4 hover:bg-gray-800">Restaurant</Link></li>
//               <li><Link to="/choclote" className="block py-2 px-4 hover:bg-gray-800">Chocolate</Link></li>
//             </ul>
//           </div>

//           {/* Models Dropdown */}
//           <div className="relative group">
//             <button className="text-lg font-medium text-gray-600 hover:text-black transition">
//               Models
//             </button>
//             <ul className="absolute left-0 mt-2 bg-black text-white rounded-md w-64 shadow-lg hidden group-hover:block">
//               <li><Link to="/" className="block py-2 px-4 hover:bg-gray-800">Displays</Link></li>
//               <li><Link to="/" className="block py-2 px-4 hover:bg-gray-800">Multi Decks</Link></li>
//               <li><Link to="/" className="block py-2 px-4 hover:bg-gray-800">Islands</Link></li>
//             </ul>
//           </div>

//           <Link to="/motarization" className="text-lg font-medium text-gray-600 hover:text-black transition">
//             Case Studies
//           </Link>
//           <Link to="/contactus" className="text-lg font-medium text-gray-600 hover:text-black transition">
//             Contact Us
//           </Link>

//           {/* 🔍 Search Bar */}
//           <div className="relative hidden lg:block">
//             <input
//               type="text"
//               placeholder="Search..."
//               className="w-40 px-4 py-2 border border-gray-300 rounded-full shadow-md focus:ring-2 focus:ring-gray-400"
//             />
//             <button className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500">
//               <FontAwesomeIcon icon={faSearch} />
//             </button>
//           </div>
//         </nav>

//         {/* 📞 Contact Details */}
//         <div className="hidden xl:flex items-center gap-6">
//           <a href="tel:+123456789" className="text-gray-600 flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faPhone} className="text-lg" />
//             <span className="text-lg font-medium">+1 234 567 89</span>
//           </a>
//           <a href="mailto:info@example.com" className="text-gray-600 flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faEnvelope} className="text-lg" />
//             <span className="text-lg font-medium">info@example.com</span>
//           </a>
//         </div>
//       </div>
//     </div>


//         {/* Mobile Hamburger Menu */}
//         <header>
//       <nav className="flex items-center justify-between">
//         {/* Hamburger Menu */}
//         <div className="absolute lg:hidden text-black  top-3 right-4 md:right-10">
//           <button
//             onClick={toggleSidebar}
//             ref={toggleRef}
//             className="p-4  text-black  relative z-30"
//           >
//             <i
//               className="fa fa-bars text-black text-3xl md:text-4xl"
//               aria-hidden="true"
//             ></i>
//           </button>
//         </div>

//         {/* Sidebar */}
//         <div
//           ref={sidebarRef}
//           className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
//             isSidebarOpen ? "translate-x-0" : "translate-x-full"
//           }`}
//         >
//           <ul className="p-2 text-center font-alumni text-xl space-y-4">
//             {/* Main Options */}
//             <li>
//               <button
//                 onClick={() => toggleMenu("need")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Models
//                 <span>{expandedMenus.need ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.need ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                     Displays
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                    Multi Decks
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Islands
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Semi Verticals
//                   </Link>
//                 </li> <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   More Solutions
//                   </Link>
//                 </li> <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Intelligent Solutions
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("shades")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Business Areas
//                 <span>{expandedMenus.shades ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.shades
//                     ? "max-h-80 opacity-100"
//                     : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/cofee" className="block py-1 pl-4">
//                     Coffee Shop
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/bakerypastry" className="block py-1 pl-4">
//                     Bakery & Pastry
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/butchery" className="block py-1 pl-4">
//                   Butchery & Charcuterie
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Supermarket & C-Stores
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Take-Away
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/restaurent" className="block py-1 pl-4">
//                   Restaurant & Self-Service
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/choclote" className="block py-1 pl-4">
//                   Chocolate 
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Ice Cream 
//                   </Link>
//                 </li> <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Sushi  
//                   </Link>
//                 </li> <li>
//                   <Link to="/" className="block py-1 pl-4">
//                   Fish & Seafood 
//                   </Link>
//                 </li>
//               </ul>
//             </li>
           
           
//             <li>
//               <Link to="/aboutus" className="block py-2 font-mono">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="block py-2 font-mono">
//                 Contact Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="block py-2 font-mono">
//                Case Studies
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </nav>
//     </header>

//     </header>
//   );
// };

// export default Header;

// working header without search bar 25/mar
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { faEnvelope, faPhone, faSearch } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// const Header = () => {
//   const [hoveredMenu, setHoveredMenu] = useState(null);
//   const [timeoutId, setTimeoutId] = useState(null);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isBlindsOpen, setIsBlindsOpen] = useState(false);
//   const [isShadesOpen, setIsShadesOpen] = useState(false);
//   const [isBrowseOpen, setIsBrowseOpen] = useState(false);


//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);
  
  
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [expandedMenus, setExpandedMenus] = useState({
//     need: false,
//     shades: false,
//     blinds: false,
//   });

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const toggleMenu = (menu) => {
//     setExpandedMenus((prev) => ({
//       ...prev,
//       [menu]: !prev[menu],
//     }));
//   };
//     useEffect(() => {
//       const handleClickOutside = (event) => {
//         if (
//           isSidebarOpen &&
//           sidebarRef.current &&
//           !sidebarRef.current.contains(event.target) &&
//           !toggleRef.current.contains(event.target)
//         ) {
//           setIsSidebarOpen(false);
//         }
//       };
//       // Add event listener to document
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => {
//         // Cleanup the event listener
//         document.removeEventListener('mousedown', handleClickOutside);
//       };
//     }, [isSidebarOpen]);



//   const handleMouseEnter = (menu) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       setTimeoutId(null);
//     }
//     setHoveredMenu(menu);
//   };

//   const handleMouseLeave = () => {
//     const id = setTimeout(() => {
//       setHoveredMenu(null);
//     }, 300); // Delay before closing the dropdown
//     setTimeoutId(id);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen((prev) => !prev);
//   };

//   const toggleBlindsMenu = () => {
//     setIsBlindsOpen((prev) => !prev);
//   };

//   const toggleShadesMenu = () => {
//     setIsShadesOpen((prev) => !prev);
//   };

//   const toggleBrowseMenu = () => {
//     setIsBrowseOpen((prev) => !prev);
//   };

//   return (
//     <header  className= "  font-normal   bg-[#ffff]  w-full z-50">

// <div className=' flex justify-around items-center'>
//   {/* Logo */}
//   <div className="text-3xl text-gray-800">
//         <a href="/">
//           <img className="xl:w-40 h-20" src="/images/dsgo2.png" alt="Logo" />
//         </a>
//       </div>
//        <div className=" flex flex-col gap-0 justify-between py-2 px-4 2xl:px-16">

// {/* 📞 Contact Details */}
// <div className=" hidden md:flex justify-end gap-6  font-mono">
//           <a href="tel:+123456789" className="text-black flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faPhone} className="text-lg" />
//             <span className="text-lg font-normal">+1 234 567 89</span>
//           </a>
//           <a href="mailto:info@example.com" className="text-black flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faEnvelope} className="text-lg" />
//             <span className="text-lg font-medium">info@example.com</span>
//           </a>
//         </div>

//         <div className='flex   justify-end mt-5 '>

     

//       {/* Desktop Navigation */}
//       <nav className="hidden lg:flex gap-6 xl:gap-16  items-center">
//         <div>
//           <Link to="/aboutus" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
//             About us
//           </Link>
//         </div>

//         {/* Business Areas Dropdown */}
//         <div
//           className="dropdown relative"
//           onMouseEnter={() => handleMouseEnter('blinds')}
//           onMouseLeave={handleMouseLeave}
//         >
//           <button className="xl:text-xl text-black font-normal  hover:underline underline-offset-4">Business Areas</button>
//           {hoveredMenu === 'blinds' && (
//             <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] font-anek rounded-lg text-xl text-white text-center w-80 z-50 shadow-lg">
//               <li>
//                 <Link to="/cofee" className="block py-1 pl-4 pt-4">Coffee Shop</Link>
//               </li>
//               <li>
//                 <Link to="/bakerypastry" className="block py-1 pl-4">Bakery & Pastry</Link>
//               </li>
//               <li>
//                 <Link to="/butchery" className="block py-1 pl-4">Butchery & Charcuterie</Link>
//               </li>
//               <li>
//                 <Link to="/supermarket" className="block py-1 pl-4">Supermarket & C-Stores</Link>
//               </li>
//               <li>
//                 <Link to="/takeaway" className="block py-1 pl-4">Take-Away</Link>
//               </li>
//               <li>
//                 <Link to="/restaurent" className="block py-1 pl-4">Restaurant & Self-Service</Link>
//               </li>
//               <li>
//                 <Link to="/choclote" className="block py-1 pl-4">Chocolate</Link>
//               </li>
//               <li>
//                 <Link to="/icecream" className="block py-1 pl-4">Ice Cream</Link>
//               </li>
//               <li>
//                 <Link to="/sushi" className="block py-1 pl-4">Sushi</Link>
//               </li>
//               <li>
//                 <Link to="/seafood" className="block py-1 pl-4">Fish & Seafood</Link>
//               </li>
//             </ul>
//           )}
//         </div>

//         {/* Models Dropdown */}
      
//         <div>
//           <Link to="/mainhomemodel" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
//           Models
//           </Link>
//         </div>
       

//         {/* Case Studies and Contact Us Links */}
//         <a href="/casestudies" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Case Studies</a>
//         <a href="/contactus" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Contact us</a>



//       {/* 🔍 Search Bar */}
//       <div className="relative hidden lg:block">
//             <input
//               type="text"
//               placeholder="Search..."
//               className="w-60 px-4 py-2 border border-gray-300 rounded-full shadow-md focus:ring-2 focus:ring-gray-400"
//             />
//             <button className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500">
//               <FontAwesomeIcon icon={faSearch} />
//             </button>
//           </div>

//         </nav>
//         </div>

//     </div>
//     </div>


//         {/* Mobile Hamburger Menu */}
//         <header>
//       <nav className="flex items-center justify-between">
//         {/* Hamburger Menu */}
//         <div className="absolute lg:hidden text-black top-4  md:top-8 right-4 md:right-10">
//           <button
//             onClick={toggleSidebar}
//             ref={toggleRef}
//             className="p-4  text-black  relative z-30"
//           >
//             <i
//               className="fa fa-bars text-black text-3xl md:text-4xl"
//               aria-hidden="true"
//             ></i>
//           </button>
//         </div>

//         {/* Sidebar */}
//         <div
//           ref={sidebarRef}
//           className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
//             isSidebarOpen ? "translate-x-0" : "translate-x-full"
//           }`}
//         >
//           <ul className="p-2 text-center font-alumni text-xl space-y-4">
//             {/* Main Options */}
          
//               <li>
//               <Link to="/mainhomemodel" className="block py-2 font-mono">
//                 Models
//               </Link>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("shades")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Business Areas
//                 <span>{expandedMenus.shades ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.shades
//                     ? "max-h-96 opacity-100"
//                     : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/cofee" className="block py-1 pl-4">
//                     Coffee Shop
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/bakerypastry" className="block py-1 pl-4">
//                     Bakery & Pastry
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/butchery" className="block py-1 pl-4">
//                   Butchery & Charcuterie
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/supermarket" className="block py-1 pl-4">
//                   Supermarket & C-Stores
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/takeaway" className="block py-1 pl-4">
//                   Take-Away
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/restaurent" className="block py-1 pl-4">
//                   Restaurant & Self-Service
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/choclote" className="block py-1 pl-4">
//                   Chocolate 
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/icecream" className="block py-1 pl-4">
//                   Ice Cream 
//                   </Link>
//                 </li> <li>
//                   <Link to="/sushi" className="block py-1 pl-4">
//                   Sushi  
//                   </Link>
//                 </li> <li>
//                   <Link to="/seafood" className="block py-1 pl-4">
//                   Fish & Seafood 
//                   </Link>
//                 </li>
//               </ul>
//             </li>
          
           
//             <li>
//               <Link to="/aboutus" className="block py-2 font-mono">
//                 About us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contactus" className="block py-2 font-mono">
//                 Contact us
//               </Link>
//             </li>
//             <li>
//               <Link to="/casestudies" className="block py-2 font-mono">
//                Case Studies
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </nav>
//     </header>

//     </header>
//   );
// };

// export default Header;

// added search bar functionality
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { faEnvelope, faPhone, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Header = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBlindsOpen, setIsBlindsOpen] = useState(false);
  const [isShadesOpen, setIsShadesOpen] = useState(false);
  const [isBrowseOpen, setIsBrowseOpen] = useState(false);


  const toggleRef = useRef(null);
  const sidebarRef = useRef(null);
  
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({
    need: false,
    shades: false,
    blinds: false,
  });
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);

  // List of pages with their corresponding routes
  const pages = [
    { name: "Coffee Shop", path: "/cofee", type: "Page" },
    { name: "Bakery & Pastry", path: "/bakerypastry", type: "Page" },
    { name: "Restaurant", path: "/restaurent", type: "Page" },
    { name: "Chocolate Display", path: "/choclote", type: "Page" },
    { name: "Butchery & Charcuterie", path: "/butchery", type: "Page" },
    { name: "Supermarket", path: "/supermarket", type: "Page" },
    { name: "Takeaway", path: "/takeaway", type: "Page" },
    { name: "Ice Cream", path: "/icecream", type: "Page" },
    { name: "Sushi", path: "/sushi", type: "Page" },
    { name: "Seafood", path: "/seafood", type: "Page" },
    { name: "Main Home Model", path: "/mainhomemodel", type: "Page" },
    { name: "Display", path: "/display", type: "Page" },
    { name: "Multideck", path: "/multideck", type: "Page" },
    { name: "Islands", path: "/islands", type: "Page" },
    { name: "Semi Verticals", path: "/semiverticals", type: "Page" },
    { name: "Intelligent", path: "/intelligent", type: "Page" },
    { name: "More Solutions", path: "/moresolutions", type: "Page" },
  ];

  // List of products with their corresponding routes
  const products = [
    { name: "Vista", path: "/vista", type: "Product" },
    { name: "E-line", path: "/e-line", type: "Product" },
    { name: "Kubo", path: "/kubo", type: "Product" },
    { name: "Daisy ", path: "/daisy-upper", type: "Product" },
    { name: "Daisy ", path: "/daisy-lower", type: "Product" },
    { name: "Daisy Ice", path: "/daisy-ice", type: "Product" },
    { name: "Minimal", path: "/minimal", type: "Product" },
    { name: "Scoop", path: "/scoop", type: "Product" },
    { name: "Iris", path: "/iris", type: "Product" },
    { name: "Columbus ", path: "/Columbus-lower", type: "Product" },
    { name: "Pura", path: "/pura", type: "Product" },
    { name: "Passionlux", path: "/passionlux", type: "Product" },
    { name: "Prestige2", path: "/Prestige2", type: "Product" },
    { name: "Click & Collect", path: "/CLICK&COLLECT", type: "Product" },
    { name: "United Buy Bye", path: "/UNITEDBUYBYE", type: "Product" },
    { name: "Columbus", path: "/COLUMBUS", type: "Product" },
    { name: "Futuro 2", path: "/FUTURO-22", type: "Product" },
    { name: "Futuro 2", path: "/Futuro-2", type: "Product" },
    { name: "United", path: "/United", type: "Product" },
    { name: "EXPOBZ", path: "/EXPOBZ", type: "Product" },
    { name: "Futuro Expo", path: "/FUTUROEXPO", type: "Product" },
    { name: "Futuro Island", path: "/FUTUROISLAND", type: "Product" },
    { name: "Urban", path: "/URBAN", type: "Product" },
    { name: "Vista Grab and Go", path: "/vista-grab-and-go", type: "Product" },
    { name: "Futuro Combi ", path: "/FuturoCombi-lower", type: "Product" },
    { name: "Victory", path: "/Victory", type: "Product" },
    { name: "Fresco Combi ", path: "/FrescoCombi-lower", type: "Product" },
    { name: "Futuro2 ", path: "/FUTURO2-upper", type: "Product" },
    { name: "Futuro Fish", path: "/FUTUROFISH", type: "Product" },
  ];
 // Combine both pages and products for unified searching
 const allItems = [...pages, ...products];

 // Handle search query changes
 const handleSearchChange = (e) => {
   const query = e.target.value;
   setSearchQuery(query);

   if (query.trim() === "") {
     setFilteredResults([]);
     return;
   }

   // Filter pages and products based on the search query
   const filtered = allItems.filter((item) =>
     item.name.toLowerCase().includes(query.toLowerCase())
   );

   setFilteredResults(filtered);
 };

 // Handle navigation on selection
 const handleNavigation = (path) => {
   navigate(path);
   setSearchQuery("");
   setFilteredResults([]);
 };

 const handleKeyDown = (e) => {
   if (e.key === "Enter" && filteredResults.length > 0) {
     navigate(filteredResults[0].path);
     setSearchQuery("");
     setFilteredResults([]);
   }
 };
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          isSidebarOpen &&
          sidebarRef.current &&
          !sidebarRef.current.contains(event.target) &&
          !toggleRef.current.contains(event.target)
        ) {
          setIsSidebarOpen(false);
        }
      };
      // Add event listener to document
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Cleanup the event listener
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isSidebarOpen]);



  const handleMouseEnter = (menu) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setHoveredMenu(menu);
  };

  const handleMouseLeave = () => {
    const id = setTimeout(() => {
      setHoveredMenu(null);
    }, 300); // Delay before closing the dropdown
    setTimeoutId(id);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const toggleBlindsMenu = () => {
    setIsBlindsOpen((prev) => !prev);
  };

  const toggleShadesMenu = () => {
    setIsShadesOpen((prev) => !prev);
  };

  const toggleBrowseMenu = () => {
    setIsBrowseOpen((prev) => !prev);
  };

  return (
    <header  className= "  font-normal   bg-[#ffff]  w-full z-50">

<div className=' flex pl-6 lg:pl-0  md:justify-around items-center'>
  {/* Logo */}
  <div className="text-3xl text-gray-800">
        <a href="/">
          <img className=" h-16 md:h-20 xl:w-40 xl:h-20" src="/images/dsgo2.png" alt="Logo" />
        </a>
      </div>

       <div className=" flex flex-col gap-0 justify-between py-2 px-4 2xl:px-16">

{/* 📞 Contact Details */}
<div className=" hidden md:flex justify-end gap-6  font-mono">
          <a href="tel:+16474687434" className="text-black flex items-center gap-2 hover:text-black transition">
            <FontAwesomeIcon icon={faPhone} className="text-lg" />
            <span className="text-lg font-normal">+1 647 468 7434</span>
          </a>
          <a href="mailto:FGomes@dsgo.ca" className="text-black flex items-center gap-2 hover:text-black transition">
            <FontAwesomeIcon icon={faEnvelope} className="text-lg" />
            <span className="text-lg font-medium">FGomes@dsgo.ca</span>
          </a>
        </div>

        <div className='flex   justify-end mt-5 '>

     

      {/* Desktop Navigation */}
      <nav className="hidden lg:flex gap-6 xl:gap-16  items-center">
        <div>
          <Link to="/aboutus" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
            About us
          </Link>
        </div>

        {/* Business Areas Dropdown */}
        <div
          className="dropdown relative"
          onMouseEnter={() => handleMouseEnter('blinds')}
          onMouseLeave={handleMouseLeave}
        >
          <button className="xl:text-xl text-black font-normal  hover:underline underline-offset-4">Business Areas</button>
          {hoveredMenu === 'blinds' && (
            <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] font-anek rounded-lg text-xl text-white text-center w-80 z-50 shadow-lg">
              <li>
                <Link to="/cofee" className="block py-1 pl-4 pt-4">Coffee Shop</Link>
              </li>
              <li>
                <Link to="/bakerypastry" className="block py-1 pl-4">Bakery & Pastry</Link>
              </li>
              <li>
                <Link to="/butchery" className="block py-1 pl-4">Butchery & Charcuterie</Link>
              </li>
              <li>
                <Link to="/supermarket" className="block py-1 pl-4">Supermarket & C-Stores</Link>
              </li>
              <li>
                <Link to="/takeaway" className="block py-1 pl-4">Take-Away</Link>
              </li>
              <li>
                <Link to="/restaurent" className="block py-1 pl-4">Restaurant & Self-Service</Link>
              </li>
              <li>
                <Link to="/choclote" className="block py-1 pl-4">Chocolate</Link>
              </li>
              <li>
                <Link to="/icecream" className="block py-1 pl-4">Ice Cream</Link>
              </li>
              <li>
                <Link to="/sushi" className="block py-1 pl-4">Sushi</Link>
              </li>
              <li>
                <Link to="/seafood" className="block py-1 pl-4">Fish & Seafood</Link>
              </li>
            </ul>
          )}
        </div>

        {/* Models Dropdown */}
      
        <div>
          <Link to="/mainhomemodel" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
          Models
          </Link>
        </div>
       

        {/* Case Studies and Contact Us Links */}
        <a href="/casestudies" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Case Studies</a>
        <a href="/contactus" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Contact us</a>



      {/* 🔍 Search Bar */}
      <div className="relative hidden lg:block">
      <div className="relative">
        <input
          type="text"
          placeholder="Search pages & products"
          className="w-full px-8 py-2 border border-gray-300 rounded-full shadow-md focus:ring-2 focus:ring-gray-400"
          value={searchQuery}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
        />
        <button className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500">
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>

      {/* Display filtered results */}
      {filteredResults.length > 0 && (
        <div className="absolute z-10 w-full bg-white border rounded-lg shadow-md mt-2">
          {filteredResults.map((item, index) => (
            <div
              key={index}
              className="p-3 hover:bg-gray-100 cursor-pointer flex justify-between"
              onClick={() => handleNavigation(item.path)}
            >
              <span>{item.name}</span>
              <span className="text-xs text-gray-500">{item.type}</span>
            </div>
          ))}
        </div>
      )}
          </div>

        </nav>
        </div>

    </div>
    </div>


        {/* Mobile Hamburger Menu */}
        <header>
      <nav className="flex items-center justify-between">
        {/* Hamburger Menu */}
        <div className="absolute lg:hidden text-black top-0  md:top-6 right-4 md:right-10">
          <button
            onClick={toggleSidebar}
            ref={toggleRef}
            className="p-4  text-black  relative z-30"
          >
            <i
              className="fa fa-bars text-black text-3xl md:text-4xl"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        {/* Sidebar */}
        <div
          ref={sidebarRef}
          className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
            isSidebarOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <ul className="p-2 text-center font-alumni text-xl space-y-4">
            {/* Main Options */}
          
              <li>
              <Link to="/mainhomemodel" className="block py-2 font-mono">
                Models
              </Link>
            </li>
            <li>
              <button
                onClick={() => toggleMenu("shades")}
                className="flex justify-between w-full py-2 font-mono"
              >
                Business Areas
                <span>{expandedMenus.shades ? "-" : "+"}</span>
              </button>
              <ul
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  expandedMenus.shades
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <li>
                  <Link to="/cofee" className="block py-1 pl-4">
                    Coffee Shop
                  </Link>
                </li>
                <li>
                  <Link to="/bakerypastry" className="block py-1 pl-4">
                    Bakery & Pastry
                  </Link>
                </li>
                <li>
                  <Link to="/butchery" className="block py-1 pl-4">
                  Butchery & Charcuterie
                  </Link>
                </li>
                <li>
                  <Link to="/supermarket" className="block py-1 pl-4">
                  Supermarket & C-Stores
                  </Link>
                </li>
                <li>
                  <Link to="/takeaway" className="block py-1 pl-4">
                  Take-Away
                  </Link>
                </li>
                <li>
                  <Link to="/restaurent" className="block py-1 pl-4">
                  Restaurant & Self-Service
                  </Link>
                </li>
                <li>
                  <Link to="/choclote" className="block py-1 pl-4">
                  Chocolate 
                  </Link>
                </li>
                <li>
                  <Link to="/icecream" className="block py-1 pl-4">
                  Ice Cream 
                  </Link>
                </li> <li>
                  <Link to="/sushi" className="block py-1 pl-4">
                  Sushi  
                  </Link>
                </li> <li>
                  <Link to="/seafood" className="block py-1 pl-4">
                  Fish & Seafood 
                  </Link>
                </li>
              </ul>
            </li>
          
           
            <li>
              <Link to="/aboutus" className="block py-2 font-mono">
                About us
              </Link>
            </li>
            <li>
              <Link to="/contactus" className="block py-2 font-mono">
                Contact us
              </Link>
            </li>
            <li>
              <Link to="/casestudies" className="block py-2 font-mono">
               Case Studies
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    </header>
  );
};

export default Header;

// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { faEnvelope, faPhone, faSearch } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// const Header = () => {
//   const [hoveredMenu, setHoveredMenu] = useState(null);
//   const [timeoutId, setTimeoutId] = useState(null);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isBlindsOpen, setIsBlindsOpen] = useState(false);
//   const [isShadesOpen, setIsShadesOpen] = useState(false);
//   const [isBrowseOpen, setIsBrowseOpen] = useState(false);


//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);
  
  
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [expandedMenus, setExpandedMenus] = useState({
//     need: false,
//     shades: false,
//     blinds: false,
//   });

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const toggleMenu = (menu) => {
//     setExpandedMenus((prev) => ({
//       ...prev,
//       [menu]: !prev[menu],
//     }));
//   };
//     useEffect(() => {
//       const handleClickOutside = (event) => {
//         if (
//           isSidebarOpen &&
//           sidebarRef.current &&
//           !sidebarRef.current.contains(event.target) &&
//           !toggleRef.current.contains(event.target)
//         ) {
//           setIsSidebarOpen(false);
//         }
//       };
//       // Add event listener to document
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => {
//         // Cleanup the event listener
//         document.removeEventListener('mousedown', handleClickOutside);
//       };
//     }, [isSidebarOpen]);



//   const handleMouseEnter = (menu) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       setTimeoutId(null);
//     }
//     setHoveredMenu(menu);
//   };

//   const handleMouseLeave = () => {
//     const id = setTimeout(() => {
//       setHoveredMenu(null);
//     }, 300); // Delay before closing the dropdown
//     setTimeoutId(id);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen((prev) => !prev);
//   };

//   const toggleBlindsMenu = () => {
//     setIsBlindsOpen((prev) => !prev);
//   };

//   const toggleShadesMenu = () => {
//     setIsShadesOpen((prev) => !prev);
//   };

//   const toggleBrowseMenu = () => {
//     setIsBrowseOpen((prev) => !prev);
//   };

//   return (
//     <header  className= "  font-normal   bg-[#ffff]  w-full z-50">

//        <div className=" flex flex-col gap-0 justify-between py-2 px-4 2xl:px-16">

// {/* 📞 Contact Details */}
// <div className=" hidden md:flex justify-end gap-6  font-mono">
//           <a href="tel:+123456789" className="text-gray-600 flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faPhone} className="text-lg" />
//             <span className="text-lg font-normal">+1 234 567 89</span>
//           </a>
//           <a href="mailto:info@example.com" className="text-gray-600 flex items-center gap-2 hover:text-black transition">
//             <FontAwesomeIcon icon={faEnvelope} className="text-lg" />
//             <span className="text-lg font-medium">info@example.com</span>
//           </a>
//         </div>

//         <div className='flex   justify-between '>

//      {/* Logo */}
//      <div className="text-3xl text-gray-800">
//         <a href="/">
//           <img className="xl:w-40 h-20" src="/images/dsgo2.png" alt="Logo" />
//         </a>
//       </div>

//       {/* Desktop Navigation */}
//       <nav className="hidden lg:flex gap-6 xl:gap-16  items-center">
//         <div>
//           <Link to="/aboutus" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
//             About us
//           </Link>
//         </div>

//         {/* Business Areas Dropdown */}
//         <div
//           className="dropdown relative"
//           onMouseEnter={() => handleMouseEnter('blinds')}
//           onMouseLeave={handleMouseLeave}
//         >
//           <button className="xl:text-xl text-black font-normal  hover:underline underline-offset-4">Business Areas</button>
//           {hoveredMenu === 'blinds' && (
//             <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] font-anek rounded-lg text-xl text-white text-center w-80 z-50 shadow-lg">
//               <li>
//                 <Link to="/cofee" className="block py-1 pl-4 pt-4">Coffee Shop</Link>
//               </li>
//               <li>
//                 <Link to="/bakerypastry" className="block py-1 pl-4">Bakery & Pastry</Link>
//               </li>
//               <li>
//                 <Link to="/butchery" className="block py-1 pl-4">Butchery & Charcuterie</Link>
//               </li>
//               <li>
//                 <Link to="/supermarket" className="block py-1 pl-4">Supermarket & C-Stores</Link>
//               </li>
//               <li>
//                 <Link to="/takeaway" className="block py-1 pl-4">Take-Away</Link>
//               </li>
//               <li>
//                 <Link to="/restaurent" className="block py-1 pl-4">Restaurant & Self-Service</Link>
//               </li>
//               <li>
//                 <Link to="/choclote" className="block py-1 pl-4">Chocolate</Link>
//               </li>
//               <li>
//                 <Link to="/icecream" className="block py-1 pl-4">Ice Cream</Link>
//               </li>
//               <li>
//                 <Link to="/sushi" className="block py-1 pl-4">Sushi</Link>
//               </li>
//               <li>
//                 <Link to="/seafood" className="block py-1 pl-4">Fish & Seafood</Link>
//               </li>
//             </ul>
//           )}
//         </div>

//         {/* Models Dropdown */}
      
//         <div>
//           <Link to="/mainhomemodel" className="xl:text-xl font-normal hover:underline underline-offset-4 text-black">
//           Models
//           </Link>
//         </div>
       

//         {/* Case Studies and Contact Us Links */}
//         <a href="/casestudies" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Case Studies</a>
//         <a href="/contactus" className="xl:text-xl text-black font-normal hover:underline underline-offset-4">Contact us</a>



//       {/* 🔍 Search Bar */}
//       <div className="relative hidden lg:block">
//             <input
//               type="text"
//               placeholder="Search..."
//               className="w-60 px-4 py-2 border border-gray-300 rounded-full shadow-md focus:ring-2 focus:ring-gray-400"
//             />
//             <button className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500">
//               <FontAwesomeIcon icon={faSearch} />
//             </button>
//           </div>
//         </nav>
//         </div>

         

//     </div>


//         {/* Mobile Hamburger Menu */}
//         <header>
//       <nav className="flex items-center justify-between">
//         {/* Hamburger Menu */}
//         <div className="absolute lg:hidden text-black top-4  md:top-8 right-4 md:right-10">
//           <button
//             onClick={toggleSidebar}
//             ref={toggleRef}
//             className="p-4  text-black  relative z-30"
//           >
//             <i
//               className="fa fa-bars text-black text-3xl md:text-4xl"
//               aria-hidden="true"
//             ></i>
//           </button>
//         </div>

//         {/* Sidebar */}
//         <div
//           ref={sidebarRef}
//           className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
//             isSidebarOpen ? "translate-x-0" : "translate-x-full"
//           }`}
//         >
//           <ul className="p-2 text-center font-alumni text-xl space-y-4">
//             {/* Main Options */}
          
//               <li>
//               <Link to="/mainhomemodel" className="block py-2 font-mono">
//                 Models
//               </Link>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("shades")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Business Areas
//                 <span>{expandedMenus.shades ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.shades
//                     ? "max-h-96 opacity-100"
//                     : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/cofee" className="block py-1 pl-4">
//                     Coffee Shop
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/bakerypastry" className="block py-1 pl-4">
//                     Bakery & Pastry
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/butchery" className="block py-1 pl-4">
//                   Butchery & Charcuterie
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/supermarket" className="block py-1 pl-4">
//                   Supermarket & C-Stores
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/takeaway" className="block py-1 pl-4">
//                   Take-Away
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/restaurent" className="block py-1 pl-4">
//                   Restaurant & Self-Service
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/choclote" className="block py-1 pl-4">
//                   Chocolate 
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/icecream" className="block py-1 pl-4">
//                   Ice Cream 
//                   </Link>
//                 </li> <li>
//                   <Link to="/sushi" className="block py-1 pl-4">
//                   Sushi  
//                   </Link>
//                 </li> <li>
//                   <Link to="/seafood" className="block py-1 pl-4">
//                   Fish & Seafood 
//                   </Link>
//                 </li>
//               </ul>
//             </li>
          
           
//             <li>
//               <Link to="/aboutus" className="block py-2 font-mono">
//                 About us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contactus" className="block py-2 font-mono">
//                 Contact us
//               </Link>
//             </li>
//             <li>
//               <Link to="/casestudies" className="block py-2 font-mono">
//                Case Studies
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </nav>
//     </header>

//     </header>
//   );
// };

// export default Header;
